
export class Api 
{
  hooks = {request: [], response: []}
  
  async get(module, method, params) {
    return this.request('GET', {module, method, params})
  }
  
  async post(module, method, data) {
    return this.request('POST', {module, method, data})
  }
  
  async request(mode, {module = 'Forex', method, params, data})
  {
    const url = `/api/${module}/${method}?${this.format_query(params)}`;
    const options = {
          method: mode,
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
    };
    
    if(mode === 'POST' && data) 
      options.body = JSON.stringify(data);
      
    this.hooks.request.forEach(hook => hook(options));
    
    const response = await fetch(url, options);
    
    this.hooks.response.forEach(hook => hook(response));
    
    if(!response.ok) return await this.handle_error(response);
    
    const result = await response.text();
    
    return result ? JSON.parse(result) : null;
  }

  format_query(params) {
    return params && Object.entries(params).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&') || ''
  }
  
  on_request(fn) 
  {
    this.hooks.request.push(fn);
  }
  
  on_response(fn) 
  {
    this.hooks.response.push(fn);
  }
  
  async handle_error(response) {
    
    response.validation = await this.get_validation_result(response)
    return Promise.reject(response)
  }
  
  async get_validation_result(response) {
    return response.status == 400 && await response.json() || null
  }
}

export const api = new Api();

window.api = api;